





import { Component, Prop } from "vue-property-decorator";
import DataTable from "@/shared/components/data-table.vue";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
import LogAcesso from "../components/LogAcesso.vue";

@Component({
  components: {
    DataTable,
    LogAcesso,
  },
})
export default class TabLogAcesso extends mixins(GlobalMixin) {
  @Prop() idConsultor!: number;
}
